import { render, staticRenderFns } from "./EditCourseCategory.vue?vue&type=template&id=541bb5a2&scoped=true"
import script from "./EditCourseCategory.vue?vue&type=script&lang=js"
export * from "./EditCourseCategory.vue?vue&type=script&lang=js"
import style0 from "./EditCourseCategory.vue?vue&type=style&index=0&id=541bb5a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541bb5a2",
  null
  
)

export default component.exports